import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import './assets/default/css/main.css'
import './assets/default/css/new_main.css'
import './assets/default/css/icon.css'
// import './assets/icon/iconfont.css'

import global from './utils/variable.js'
Vue.prototype.global = global
import common from './utils/common.js'
Vue.prototype.common = common
import curl from './utils/curl.js'
Vue.prototype.curl = curl
import lang from './utils/language'
Vue.prototype.lang = lang

import obtain from './utils/obtain.js'
Vue.prototype.obtain = obtain

import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

import audio from 'vue-mobile-audio'
Vue.use(audio)

import axios from 'axios'
axios.defaults.timeout = 60000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;chartset=uft-8'        //配置请求头
axios.defaults.baseURL = process.env.API_HOST
Vue.prototype.$axios = axios

import EXIF from 'exif-js'
Vue.prototype.EXIF = EXIF

Vue.prototype.global.lang = localStorage.getItem('lang')?localStorage.getItem('lang'):Vue.prototype.global.lang

Vue.config.productionTip = false
Vue.use(ElementUI)
// Vue.prototype.back = () => router.back(-1)
Vue.prototype.back = data => {
    data=parseInt(data)?parseInt(data):-1
    window.history.go(data)
}

if (window.performance.navigation.type == 1 && Vue.prototype.common.isIos()) {
    sessionStorage.setItem("wxsdk_url",window.location.href)
}

import VueAMap from 'vue-amap'
Vue.use(VueAMap)
//初始化
VueAMap.initAMapApiLoader({
    key: '869c4484aad69a3d7d8698f733755f21',
    plugin: ['AMap.PlaceSearch', 'AMap.Scale', 'AMap.Geolocation', 'AMap.Geocoder', 'AMap.PlaceSearch'],//依赖配置，根据自己的需求引入
})

router.beforeEach((to, from, next) => {
    if(Vue.prototype.common.isIos() && !sessionStorage.getItem('wxsdk_url')){
        sessionStorage.setItem("wxsdk_url",window.location.href)
    }
    let voucher = Vue.prototype.common.voucher()
    if ((!voucher||voucher=='undefined')&&to.meta.auth) {
        Vue.prototype.global.login_back = to.path
        next({ path: '/login' })
    } else {
        // console.log("from",from.name)
        // console.log("to",to.name)
        if(from.name=="msg_info"&&to.name=="orders_notify"){
            window.history.go(-2)
            // next({ path: '/msg' })
        }else if(from.name=="networkcard_info"&to.name=="orders_payment"){
            next({ path: '/networkcard' })
        }else if(from.name=="hotel"&to.name=="orders_payment"){
            next({ path: '/' })
        }else{
            if (to.meta.title) { document.title = Vue.prototype.lang.field(to.meta.title) }
            next()
        }
        
    }
})
router.afterEach(route => {

})

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js